import React, { useEffect, useState } from "react";
import HeroSection from "./HeroSection";
import SearchAll from "./SearchAll";
import CandidateBanner from "./CandidateBanner";
import { getMetadataByPage } from "../../API/Api";
import { Helmet } from "react-helmet-async";

const Candidates = () => {
  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    const fetchMetadata = async () => {
      const data = await getMetadataByPage("candidates");
      setMetadata(data);
    };
    fetchMetadata();
  }, []);
  return (
    <>
      {metadata && (
        <Helmet>
          <title>{metadata?.title || "Anaxistech"}</title>
          <meta
            name="description"
            content={metadata?.description || "Default description"}
          />
          <meta
            name="keywords"
            content={metadata?.keywords || "tech, services"}
          />
          <meta
            property="og:title"
            content={metadata?.ogTitle || metadata?.title || "Anaxistech"}
          />
          <meta
            property="og:description"
            content={
              metadata?.ogDescription ||
              metadata?.description ||
              "Default description"
            }
          />
          <meta
            property="og:image"
            content={metadata?.ogImage || "/default-image.png"}
          />
        </Helmet>
      )}
      <HeroSection />
      <SearchAll />
      <CandidateBanner />
    </>
  );
};

export default Candidates;
